import { CopyAll, Refresh } from '@mui/icons-material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { Button, Grid } from '@mui/material'
import {
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid'
import { useLocation, useParams } from 'react-router-dom'
import RowSizeButton from './RowSizeButton'
import { LoadingButton } from '@mui/lab'

export function GridToolbar({
    handleAddRow,
    createPrivileges,
    checked,
    handleReset,
    hiddenRefresh,
    hiddenSize,
    hiddenFilter,
    hiddenColumn,
    hiddenExport,
    hiddenSearch,
    showCopyLine,
    size,
    hiddenContent,
    addRowReqPrivileges,
    reviseId,
    copyLine,
    loadingAdd,
}) {
    const { dataId } = useParams()
    let content
    let copyLineButton
    const url = useLocation().pathname

    switch (url) {
        // Register
        case '/approval-roles':
            content = createPrivileges ? (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            ) : null
            break

        case `/requests/${dataId}`:
            content = createPrivileges ? (
                <>
                    {/*  <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small"> Add </Button> */}
                    <LoadingButton
                        loading={loadingAdd}
                        onClick={handleAddRow}
                        startIcon={<AddCircleOutlineIcon />}
                    >
                        Add
                    </LoadingButton>
                </>
            ) : null
            copyLineButton = <Button onClick={copyLine} startIcon={<CopyAll />} size="small">
                Copy line
            </Button>
            break

        case `/orders/${dataId}`:
            content = createPrivileges ? (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            ) : null
            copyLineButton = <Button onClick={copyLine} startIcon={<CopyAll />} size="small">
                Copy line
            </Button>
            break

        case `/approval-stages/${dataId}`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            )
            break
        case `/rfqs`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            )
            break
        case `/rfqs/${dataId}`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            )
            break
        case `/invoice-register`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            )
            break
        case `/supplier-evaluation`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            )
            break
        case `/individual-vendor`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            )
            break
        case `/supplier-evaluation/${dataId}`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            )
            break
        case `/invoice-match/${dataId}`:
            copyLineButton = <Button onClick={copyLine} startIcon={<CopyAll />} size="small">
                Copy line
            </Button>
            break
        case '/analysis-codes':
        case '/analysis-dimensions':
        case '/analysis-structures':
            content = checked ? (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            ) : null
            break
        case '/evaluation-form':
        case '/evaluation-form-2':
            content = checked ? (
                // && (!reviseId || reviseId === '0')
                <Button onClick={handleAddRow} sx={{ p: 0, ml: 2 }} startIcon={<AddCircleOutlineIcon />} size="small">
                    Add
                </Button>
            ) : null
            break
        case `/vendors/${dataId}`:
            content = (
                <Button onClick={handleAddRow} startIcon={<AddCircleOutlineIcon />} size="small">
                    {' '}
                    Add{' '}
                </Button>
            )
            break
        default:
            content = null
            break
    }

    return (
        <>
            <GridToolbarContainer>
                <Grid container display="flex" justifyContent="space-between" alignItems="center">
                    <Grid
                        item
                        xs={12}
                        sm={8}
                        md={7}
                        lg={6}
                        xl={6}
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}
                    >
                        <Grid item xs={12} hidden={hiddenColumn}>
                            <GridToolbarColumnsButton />
                        </Grid>

                        <Grid item xs={12} hidden={hiddenFilter}>
                            <GridToolbarFilterButton />
                        </Grid>

                        <Grid item xs={12} hidden={hiddenSize}>
                            <RowSizeButton />
                        </Grid>

                        <Grid item xs={12} hidden={hiddenExport}>
                            <GridToolbarExport />
                        </Grid>

                        <Grid item xs={12} hidden={hiddenRefresh}>
                            <Button startIcon={<Refresh />} onClick={handleReset} size="small">
                                Refresh{' '}
                            </Button>
                        </Grid>

                        <Grid item xs={12} hidden={hiddenContent}>
                            {content}
                        </Grid>
                        <Grid item xs={12} hidden={!showCopyLine}>
                            {copyLineButton}
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={4} hidden={hiddenSearch} paddingLeft={5}>
                        <GridToolbarQuickFilter />
                    </Grid>
                </Grid>
            </GridToolbarContainer>
        </>
    )
}